/**
 *
 *
 */
import { BaseComponent } from '../../base-component';
import { ClientComponentLogger } from '../../client-component-logger';
import { RELOAD_COMPONENT_TOPIC } from '../../constants';
import { ReloadEventData } from '../../ui-aggregator/client/types';
import { BaseComponent2 } from './base-component2';
import { BaseComponent2Factory } from './base-component2-factory';

export type DeferredPromise = { promise: Promise<void>; resolve: CallableFunction; reject: CallableFunction };
export type ExtendedBaseComponent = new () => BaseComponent | BaseComponent2;
export type ClientComponentParam = { [classNameKey: string]: ExtendedBaseComponent };

/**
 *
 */
export class ClientComponentRunner {
    /**
 *
 */
    private readonly initLock: DeferredPromise;

    protected logger: ClientComponentLogger;

    /**
 *
 *
 *
 *
 */
    constructor(
        public componentFactory: () => BaseComponent | BaseComponent2,
        public readonly componentName: string
    ) {
        this.logger = new ClientComponentLogger(componentName);
        this.initLock = this.createDeferred();
    }

    /**
 *
 */
    public async runClientJs(): Promise<Array<BaseComponent2 | BaseComponent>> {
        let components: Array<BaseComponent2 | BaseComponent>;

        if (this.componentFactory() instanceof BaseComponent2) {
            const baseComponent2Factory = new BaseComponent2Factory(
                this.componentFactory as () => BaseComponent2,
                this.initLock,
                this.logger
            );
            components = await baseComponent2Factory.initAndBuildComponents();
        } else {
            components = await this.runClientJsForOldBaseComponent();
        }
        return components;
    }

    protected async runInitialization(component: BaseComponent): Promise<void> {
        try {
            await component.init();
            this.initLock.resolve();
        } catch (e) {
            this.logger.logError({ error: e as Error, type: 'OnInitError' });
        }
    }

    protected async registerHandlerForComponentReloadOldBaseComponent(component: BaseComponent): Promise<void> {
        o_global.eventQBus.on(RELOAD_COMPONENT_TOPIC, this.handleComponentReloadOldBaseComponent(component));
    }

    private handleComponentReloadOldBaseComponent(component: BaseComponent) {
        return async (_e: ReloadEventData) => {
            try {
                await this.waitForInitialization();
                await component.onHtmlLoaded();
            } catch (e) {
                this.logger.logError({ error: e as Error, type: 'OnHtmlLoadedError' });
            }
        };
    }

    /**
 *
 */
    protected async waitForInitialization(): Promise<void> {
        await this.initLock.promise;
    }

    private async runClientJsForOldBaseComponent() {
        const components: Array<BaseComponent> = [];
        try {
            const component = this.componentFactory() as BaseComponent;
            await component.setLogger(this.logger);
            await this.registerHandlerForComponentReloadOldBaseComponent(component);
            await this.runInitialization(component);
            components.push(component);
        } catch (e) {
            this.logger.logError({ error: e as Error });
        }
        return components;
    }

    private createDeferred(): DeferredPromise {
        const result: Partial<DeferredPromise> = {};

        result.promise = new Promise((res, rej) => {
            result.resolve = res;
            result.reject = rej;
        });

        return result as DeferredPromise;
    }
}

/**
 *
 */
export async function runClientComponentPromise(baseComponentClassDef: ClientComponentParam): Promise<void> {
    if (!baseComponentClassDef) {
        throw new Error(`runClientComponentPromise: baseComponentClassDef parameter has wrong value: ${baseComponentClassDef}`);
    }
    const keys = Object.keys(baseComponentClassDef);
    const values = Object.values(baseComponentClassDef);
    if (keys.length !== 1 || !values[0]) {
        throw new Error('wrong params for `runClientComponentPromise`' + JSON.stringify(baseComponentClassDef));
    }

    const ClassConstructor = values[0];
    const className = keys[0];
    const runner = new ClientComponentRunner(() => new ClassConstructor(), className);
    await runner.runClientJs();
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function runClientComponent(baseComponentClassDef: ClientComponentParam): void {
    /*                                                                 */
    runClientComponentPromise(baseComponentClassDef);
}
